import { selectors as commonSelectors } from '~/domains/common';
import {
  selectors as agentScannersSelectors,
  actions as agentScannersActions
} from '~/domains/agentScanners';
import { isLoggedIn } from '~/utils/validations/profile';
import { getActiveOrganizationId } from '~/utils/organization';

const resolve = async ({ getState, dispatch }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);

  isLoggedIn(profile);

  if (!agentScannersSelectors.isAgentScannersFlagEnabled(state)) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }

  // Always load scanners data on navigation
  const organizationId = getActiveOrganizationId(profile);
  const isFetching = agentScannersSelectors.isFetchingScanners(state);

  if (organizationId && !isFetching) {
    await dispatch(agentScannersActions.loadAgentScanners(organizationId));
  }
};

export default resolve;
